import React from 'react'
import { useBreakpoint } from 'shared/hooks/useBreakpoint'
import { useOnKeydown } from 'shared/hooks/useOnKeydown'

interface IMenuContext {
  menuActive: boolean
  setMenuActive: (active: boolean) => void
}

const MenuContext = React.createContext<IMenuContext>({
  menuActive: false,
  setMenuActive: (active: boolean) => {}
})

function MenuContextProvider({ children }: { children: React.ReactNode }) {
  const breakpoint = useBreakpoint()
  const [menuActive, setMenuActive] = React.useState(false)
  const context = {
    menuActive,
    setMenuActive
  }

  useOnKeydown('Escape', () => {
    if (breakpoint !== 'desktop')
      setMenuActive(false)
  })

  return <MenuContext.Provider value={context}>{children}</MenuContext.Provider>
}

function useMenu() {
  const context = React.useContext(MenuContext)

  function toggle() {
    !context.menuActive === true ? document.body.classList.add('no-scroll') : document.body.classList.remove('no-scroll')
    context.setMenuActive(!context.menuActive)
  }

  function show() {
    document.body.classList.add('no-scroll')
    context.setMenuActive(true)
  }

  function hide() {
    document.body.classList.remove('no-scroll')
    context.setMenuActive(false)
  }

  return {
    menuActive: context.menuActive,
    toggle,
    show,
    hide
  }
}

export { MenuContextProvider, useMenu }
